import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `currentColor` : `var(--color-${color})`;
};
const SvgTwitterColorIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    viewBox="0 0 16 16.36"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill={getFillColor(props.color) === "currentColor" ? `var(--color-twitter)` : getFillColor(props.color)}
          d="M9.522 6.924 15.479 0h-1.411L8.895 6.012 4.764 0H0l6.247 9.091L0 16.352h1.412l5.462 -6.349 4.362 6.349H16zM7.589 9.171l-0.633 -0.905L1.92 1.063h2.168l4.064 5.813 0.633 0.905 5.283 7.556H11.9z" />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgTwitterColorStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgTwitterColorIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const TwitterColorIcon: any = SvgTwitterColorStyle;
export default TwitterColorIcon;
